<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="i_id" label="分类编号" required>{{formData.i_id}}</el-form-item>
<!--                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.i_id"  ></el-input>-->

            <el-form-item  prop="vc_name" label="分类名称" required>
                <el-input :disabled="canEdit" style="width: 200px" class="changeinput" size="mini" v-model="formData.vc_name"  ></el-input>
            </el-form-item>
            <el-form-item  prop="i_flag" label="分类属性" required>

                <el-select :disabled="canEdit" style="width: 200px"  class="marr4" v-model="formData.i_flag" size="mini"  filterable placeholder="分类属性">
                    <el-option v-for="item in sxList" :key="item.i_flag" :label="item.vc_flag" :value="item.i_flag">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="i_gsid" label="公司属性">
                <el-select :disabled="canEdit" style="width: 200px" class="marr4" v-model="formData.i_gsid" size="mini"  filterable placeholder="公司属性">
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="i_gid" label="归属组织" >
                <el-select :disabled="canEdit" style="width: 200px"  class="marr4" v-model="formData.i_gid" size="mini"  filterable clearable placeholder="归属组织">
                    <el-option v-for="itembm in gszzList" :key="itembm.i_id" :label="itembm.vc_name" :value="itembm.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否启用:"class="w50"  prop="i_state" required>
                <el-radio-group :disabled="canEdit" v-model="formData.i_state" >
                    <el-radio :label='-1'>否</el-radio>
                    <el-radio :label='1'>是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="南北code:"class="w50"  prop="vc_code_nanbei">
                <span style="margin-right: 3px">{{formData.vc_code_nanbei}}</span>
                <el-button v-if="formData.i_id!=0" type="text" @click="tosync('南北')">同步</el-button>
            </el-form-item>

<!--            <el-form-item  prop="i_type" label="应用" required>-->
<!--                <el-select :disabled="canEdit" style="width: 200px"  class="marr4" v-model="formData.i_type" size="mini" clearable filterable placeholder="请选择公司">-->
<!--                    <el-option v-for="item in yyList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item  prop="i_order" label="排序号" >
                <el-input-number :controls="false" :precision="0" :min="1" :disabled="canEdit" class="changeinput" size="mini" v-model="formData.i_order"  ></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="mini" >保存</el-button>
            </template>

            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "ChanpinFenlei",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                formData:{
                    i_id:0,
                    vc_name:'',
                    i_flag:'',
                    i_gsid:'',
                    i_gid:'',
                    i_order:'',i_state:1,
                    vc_code_nanbei:'',
                },
                disabled:false,
                canEdit:false,
                sxList:[],
                gszzList:[],
                gsList:[],
                // yyList:[{i_id:0,vc_name:'进销存'},{i_id:1,vc_name:'电商'}],
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    if(this.data){
                        if(this.data.i_id==0){
                            this.formData.i_id=this.data.i_id;
                        }else{
                            this.getProductTypeDetail();
                        }
                    }
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.findClassificationAttributes()
            this.getGroupList()
            this.getCompanyList()

            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            tosync(text){
                this.$confirm('是否同步到'+text+'系统','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:"warning"
                }).then(()=>{
                    console.log(this.formData,"this.formData")
                    this.updatesystem();
                }).catch(()=>{
                    this.$message.info('取消操作')
                })
            },
            async updatesystem(){
                let param={
                    i_id:this.formData.i_id,
                    i_typeid:this.formData.i_id,
                };
                let res=await API.saveSNProductCategory(param);
                if ( res.code == 1 ){
                    this.getProductTypeDetail();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('close')
            },
            saveForm(){
                if(this.formData.i_gsid=='')this.formData.i_gsid=0;
                if(this.formData.i_gid=='')this.formData.i_gid=0;
                if(this.formData.vc_name==''||this.formData.i_flag===''||this.formData.i_state==''){
                    this.$message.warning('请填写必需项')
                }else{
                        this.addOrupdateProductCategory()
                    this.disabled=true
                }
            },
            async addOrupdateProductCategory(){
                this.formData.operate=this.formData.i_id?1:0;
                if(this.formData.i_id==0){
                    this.formData.i_pid=this.data.i_pid;
                    this.formData.i_level=this.data.i_level;
                }
                let param=this.formData;
                let res=await API.addOrupdateProductCategory(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
            async getProductTypeDetail(){
                let param={
                    i_id:this.data.i_id

                };
                let res=await API.getProductTypeDetail(param);
                if ( res.code == 1 ){
                    this.formData=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async findClassificationAttributes(){
                let param={
                };
                let res=await API.findClassificationAttributes(param);
                if ( res.code == 1 ){
                    this.sxList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.gszzList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>